export const UnitEnum = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
};

export const UnitList = [
  { label: 'Nap', value: UnitEnum.DAY },
  { label: 'Hét', value: UnitEnum.WEEK },
  { label: 'Hónap', value: UnitEnum.MONTH },
];

export const WeekDaysList = [
  { label: 'Hétfő', value: 1 },
  { label: 'Kedd', value: 2 },
  { label: 'Szerda', value: 3 },
  { label: 'Csütörtök', value: 4 },
  { label: 'Péntek', value: 5 },
  { label: 'Szombat', value: 6 },
  { label: 'Vasárnap', value: 7 },
];

export const MonthDaysList = Array.from({ length: 31 }, (_v, k) => ({ label: `${k + 1}.`, value: k + 1 }));

export const UnitsWithFrequency = [UnitEnum.WEEK, UnitEnum.MONTH];
